module.exports = __webpack_public_path__ + "img/拼团一阶玩法.69344322.png";